import React from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { TextInput, Props as TextInputProps } from './text-input';

interface Props extends TextInputProps {
  containerStyle?: StyleProp<ViewStyle>;
  disabled?: boolean;
  inputContainerStyle?: StyleProp<ViewStyle>;
  label: string;
  onPress: () => void;
  rightElement?: React.ReactNode;
  testID?: string;
  useOuterLabel?: boolean;
  value: string;
}

export const SelectInput: React.FC<Props> = ({
  containerStyle,
  disabled = false,
  inputContainerStyle,
  label,
  onPress,
  rightElement,
  testID,
  useOuterLabel,
  value,
  ...rest
}) => {
  return (
    <TouchableOpacity
      activeOpacity={1}
      disabled={disabled}
      onPress={onPress}
      style={containerStyle}
      testID="select-input-button"
    >
      <TextInput
        containerStyle={inputContainerStyle}
        editable={!disabled}
        label={value ? label : undefined}
        onChangeText={() => {}}
        placeholder={label}
        pointerEvents="none"
        rightElement={rightElement}
        testID={testID}
        useOuterLabel={useOuterLabel}
        value={value}
        {...rest}
      />
    </TouchableOpacity>
  );
};
